<div class="align-center">
  <div class="heading-1 text-grey no-margin">
    <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
  </div>
  <div class="heading-4">{{ 'general.api_access_denied_title' | translate }}</div>
  <div>{{ 'general.api_access_denied_description' | translate }}</div>
</div>
